import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ImageLoaderDirective} from './image-loader.directive';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    ImageLoaderDirective
  ],
  exports: [
    ImageLoaderDirective
  ]
})
export class ImageLoaderModule {
}



// WEBPACK FOOTER //
// /var/www/bizisystem-frontend/src/src/app/shared/image-loader/image-loader.module.ts